import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Card from "./Card";
import routeNames from "../utils/routes.json";
import { Player } from "@lottiefiles/react-lottie-player";

export default function ProductDashboard() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(location.pathname);
  const [isLoading, setIsLoading] = useState(true);
 


  const handleTabClick = (route) => {
    setActiveTab(route);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
      }}>
        <Player
          autoplay
          loop
          src="https://assets1.lottiefiles.com/packages/lf20_raiw2hpe.json"
          style={{ height: '150px', width: '150px' }}
        />
      </div>
    );
  }


  return (
   
        <>
          <div className="sticky top-16 z-50 py-4 bg-blur backdrop-blur-md w-full">
            <div className="flex items-center justify-between sticky top-16 z-50 py-4 bg-blur backdrop-blur-md w-full">
              <h2 className="text-2xl ml-6 sm:text-3xl font-bold text-gray-800 border-black inline-block pb-1">
                Your Listed Products
              </h2>

              <Link
                to={`/product-dashboard${routeNames["add-product"]}`}
                className={`bg-black text-white px-4 py-2 mr-8 rounded-md transition hover:bg-gray-800 ${activeTab === routeNames["add-product"] ? "bg-gray-800" : ""
                  }`}
              >
                Add Product
              </Link>
            </div>
             <Card />
          </div>

         
        </>
     
  );
}